/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const PaymentServiceProviderViewR = t.interface({
  broker_psp_code: t.string,

  channel_code: t.string,

  payment_method: t.string,

  payment_type: t.string,

  psp_code: t.string
});

// optional attributes
const PaymentServiceProviderViewO = t.partial({});

export const PaymentServiceProviderView = t.intersection(
  [PaymentServiceProviderViewR, PaymentServiceProviderViewO],
  "PaymentServiceProviderView"
);

export type PaymentServiceProviderView = t.TypeOf<
  typeof PaymentServiceProviderView
>;
